"use client";

import { useSyncExternalStore } from "react";

/**
 * Общие «текущие минуты» для всего интерфейса новой версии.
 *
 * Нужен там, где на экране есть возраст чего-либо: «изменено 5 минут назад»,
 * «страница правилась на этой неделе». Такие подписи нельзя считать от
 * `Date.now()` прямо в отрисовке: на сервере время другое, и React ругался бы
 * на расхождение разметки, а компилятор React — на побочный вызов при
 * отрисовке. Здесь время приходит как внешнее хранилище: сервер отдаёт 0
 * (значит «ещё рано что-то показывать»), браузер — настоящее время.
 *
 * Часы одни на всех и тикают раз в минуту, пока на экране есть хоть один
 * потребитель: иначе каждая подпись завела бы свой таймер и своё состояние.
 */

let clockNow = 0;
let clockTimer: ReturnType<typeof setInterval> | null = null;
const clockListeners = new Set<() => void>();

function subscribeClock(onChange: () => void): () => void {
  clockListeners.add(onChange);
  clockTimer ??= setInterval(() => {
    clockNow = Date.now();
    for (const listener of clockListeners) listener();
  }, 60_000);
  return () => {
    clockListeners.delete(onChange);
    if (clockListeners.size === 0 && clockTimer) { clearInterval(clockTimer); clockTimer = null; }
  };
}

/** Значение обязано быть стабильным между вызовами, иначе React зациклится. */
function clockSnapshot(): number {
  if (!clockNow) clockNow = Date.now();
  return clockNow;
}

function clockServerSnapshot(): number {
  return 0;
}

/** Текущее время в миллисекундах; 0 до первой отрисовки в браузере. */
export function useNowMs(): number {
  return useSyncExternalStore(subscribeClock, clockSnapshot, clockServerSnapshot);
}
